export const HORIZONTAL_MARGIN = 30;
export const VERTICAL_MARGIN = 30;
